import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { NgStyle } from '@angular/common';
import type { AfterViewInit } from '@angular/core';
import { Component, Inject, Input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import { InnogyComponentRendering } from '@core/jss-models';
import { GenericRichTextDirective } from '@core/jss-utils';
import { IAdvizeService } from '@innogy/core-chatting';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  CommonUiUtilityComponentsModule,
  RichTextWrapperComponent,
} from '@legacy/common-ui-utility-components';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';

@Component({
  selector: 'wl-chatbot-iadvize-start-screen',
  templateUrl: './chatbot-iadvize-start-screen.component.html',
  standalone: true,
  imports: [
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
    CommonUiUtilityComponentsModule,
    TrackImpressionDirective,
    AutomationIdDirective,
    JssModule,
    NgStyle,
    RichTextWrapperComponent,
    GenericRichTextDirective,
    TrackLinkDirective,
  ],
})
export class ChatbotIadvizeStartScreenComponent implements AfterViewInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  constructor(
    @Inject(ENVIRONMENT_CONFIG) private readonly config: EnvironmentConfig,
    private readonly iAdvizeService: IAdvizeService
  ) {}

  ngAfterViewInit() {
    // This call is a workaround to ensure that the current element can be picked up
    // by iAdvize, even if the chatbot element not present at page-load.
    // iAdvize only scans for 'Fixed Buttons' on pageload, this call ensures our element will be discovered
    // as we trigger a re-scan of the page.
    // see: https://docs.iadvize.dev/use-cases/visitor-experience/integrating-custom-buttons-into-your-site
    if (this.isEnabled) {
      this.iAdvizeService.scanCurrentPage();
    }
  }

  get isEnabled() {
    return this.config.iAdvizeChatbot.enabled;
  }
}
